import { PropsWithChildren, useState } from "react";
import mergeCssClasses from "utils/mergeCssClasses";

import TopBar from "./components/TopBar";
import Sidebar from "./components/Sidebar";
import ProfileSettings from "./components/ProfileSettings";
import "./main-layout.scss";

export default function MainLayout({ children }: PropsWithChildren ) {

   const [ sidebar_open, setSidebarOpen ] = useState( window.innerWidth > 1400 );
   const [ show_profile_settings, setShowProfileSettings ] = useState( false );

   const showProfile = () => setShowProfileSettings( true );

   return (
      <div className={ mergeCssClasses( "main-layout", sidebar_open && "sidebar-open" )}>

         <TopBar showProfile={ showProfile }/>

         <div style={{ display: "flex", flex: "auto" }}> 

            <Sidebar
               open={ sidebar_open }
               showProfile={ showProfile }
               toggleSidebar={() => setSidebarOpen( s => !s )}
            />

            <main>
               { children }
            </main>
         </div>

         <ProfileSettings 
            show={ show_profile_settings }
            onClose={() => setShowProfileSettings( false )}   
         />
      </div>
   )
}